export class Post {
    constructor(id, title, url, fullUrl, content, shortUrl, summary, shares, views, terms, country, medias, keywords, isLive, tag, postType, textContent, imageCaption, imageSource, displayDate, publishDate, image, author, date, metas, relatives, relativesCount, readingTimeInMinutes, disclaimer, isVideo) {
        this.id = id;
        this.title = title;
        this.url = url;
        this.fullUrl = fullUrl;
        this.content = content;
        this.shortUrl = shortUrl;
        this.summary = summary;
        this.shares = shares;
        this.views = views;
        this.terms = terms;
        this.country = country;
        this.keywords = keywords;
        this.isLive = isLive;
        this.tag = tag;
        this.postType = postType;
        this.textContent = textContent;
        this.imageCaption = imageCaption;
        this.imageSource = imageSource;
        this.displayDate = displayDate;
        this.publishDate = publishDate;
        this.image = image;
        this.author = author;
        this.date = date;
        this.relatives = relatives;
        this.relativesCount = relativesCount;
        this.readingTimeInMinutes = readingTimeInMinutes;
        this.disclaimer = disclaimer;
        this.isVideo = isVideo;
        this.metas = metas;
        this.medias = medias;
    }
    filterMetas(predicate) {
        return this.metas.filter(predicate);
    }
    findMeta(predicate) {
        return this.metas.find(predicate);
    }
    filterMedias(predicate) {
        return this.medias.filter(predicate);
    }
    findMedia(predicate) {
        return this.medias.find(predicate);
    }
}
